import {
  MessageSquare,
  Type,
  Paperclip,
  PenSquare,
  MessageSquareText,
  Brain,
  Tags,
  ListChecks,
  MessageSquarePlus,
  BookOpenCheck,
  GitBranch,
  SlidersHorizontal,
  Clock,
  UserPlus,
  BookOpen,
  Webhook,
  List,
  ExternalLink,
  LayoutGrid,
  ArrowRightLeft,
  Braces,
  LayoutTemplate,
} from "lucide-react";
import { NODE_CATALOG } from "../components/FlowBuilder/AddNodePicker";

const ICON_BY_TYPE = {
  trigger: MessageSquare,
  textMessage: Type,
  sendMedia: Paperclip,
  setVariable: PenSquare,
  captureText: MessageSquareText,
  aiAskQuestion: Brain,
  aiIntentClassifier: Tags,
  aiEntityExtractor: ListChecks,
  aiResponseGenerator: MessageSquarePlus,
  aiKnowledgeBaseAnswer: BookOpenCheck,
  condition: GitBranch,
  controller: SlidersHorizontal,
  delay: Clock,
  assignAgent: UserPlus,
  knowledgeBase: BookOpen,
  webhook: Webhook,
  codeMap: Braces,
  jsonMap: Braces,
  transferToFlow: ArrowRightLeft,
  interactiveButtons: MessageSquare,
  interactiveList: List,
  interactiveUrl: ExternalLink,
  interactiveCarouselUrl: LayoutGrid,
  interactiveCarouselButton: LayoutGrid,
  template: MessageSquare,
  preApprovedTemplate: LayoutTemplate,
};

const COLOR_BY_TYPE = {
  trigger: "purple",
  aiKnowledgeBaseAnswer: "purple",
  aiAskQuestion: "purple",
  aiIntentClassifier: "purple",
  aiEntityExtractor: "purple",
  aiResponseGenerator: "purple",
  knowledgeBase: "amber",
  condition: "blue",
  controller: "orange",
  webhook: "orange",
  codeMap: "blue",
  jsonMap: "blue",
  transferToFlow: "indigo",
  interactiveButtons: "teal",
  interactiveList: "teal",
  interactiveUrl: "teal",
  interactiveCarouselUrl: "teal",
  interactiveCarouselButton: "teal",
  preApprovedTemplate: "blue",
};

const LABEL_BY_TYPE = {};
for (const group of NODE_CATALOG) {
  for (const item of group.items) {
    LABEL_BY_TYPE[item.type] = item.label;
  }
}
LABEL_BY_TYPE.template = "Template";

const ACCENT_CLASSES = {
  purple: { chip: "bg-purple-100 text-purple-800", icon: "text-purple-600", btn: "bg-purple-600 hover:bg-purple-700" },
  amber: { chip: "bg-amber-100 text-amber-800", icon: "text-amber-600", btn: "bg-amber-600 hover:bg-amber-700" },
  blue: { chip: "bg-blue-100 text-blue-800", icon: "text-blue-600", btn: "bg-blue-600 hover:bg-blue-700" },
  teal: { chip: "bg-teal-100 text-teal-800", icon: "text-teal-600", btn: "bg-teal-600 hover:bg-teal-700" },
  orange: { chip: "bg-orange-100 text-orange-800", icon: "text-orange-600", btn: "bg-orange-600 hover:bg-orange-700" },
  indigo: { chip: "bg-indigo-100 text-indigo-800", icon: "text-indigo-600", btn: "bg-indigo-600 hover:bg-indigo-700" },
  emerald: { chip: "bg-emerald-100 text-emerald-800", icon: "text-emerald-600", btn: "bg-emerald-600 hover:bg-emerald-700" },
};

export function getNodeEditorMeta(nodeType) {
  const color = COLOR_BY_TYPE[nodeType] || "blue";
  return {
    label: LABEL_BY_TYPE[nodeType] || nodeType,
    icon: ICON_BY_TYPE[nodeType] || MessageSquare,
    color,
    accent: ACCENT_CLASSES[color] || ACCENT_CLASSES.blue,
  };
}
